
<div class="login-container">
  <div class="card-wrapper">
    <div class="card">
      <div class="card-header">
        <div class="logo-container">
          <img src="assets/AivorLogo.png" alt="Aivor Logo" class="logo">
        </div>
        <h1 class="title">Welcome!</h1>
        <p class="subtitle">Sign in to your account to continue</p>
      </div>

      <div class="card-body">
        <form (submit)="onSubmit($event)" #loginForm="ngForm" class="login-form">
          <div class="form-group">
            <label for="email" class="form-label">Email Address</label>

            <input
              id="email"
              type="email"
              class="form-control"
              [(ngModel)]="formData.email"
              name="email"
              placeholder="Enter your email"
              required
              #email="ngModel"
              autocomplete="email"
            />
            <div *ngIf="email.invalid && email.touched" class="form-error">
              Please enter a valid email address
            </div>
          </div>

          <div class="form-group">
            <div class="d-flex justify-content-between align-items-center">
              <label for="password" class="form-label">Password</label>
              <a routerLink="/forgot-password" class="forgot-password">Forgot password?</a>
            </div>
            <div class="input-group">
              <input
                id="password"
                [type]="showPassword ? 'text' : 'password'"
                class="form-control"
                [(ngModel)]="formData.password"
                name="password"
                placeholder="Enter your password"
                required
                #password="ngModel"
                autocomplete="current-password"
                />
              <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="togglePasswordVisibility()"
                tabindex="-1"
              >
                <i class="bi" [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
              </button>
            </div>

            <div *ngIf="password.invalid && password.touched" class="form-error">
              Password is required
            </div>
          </div>

          <div class="form-group remember-me">
            <label class="checkbox-container">
              <input
                type="checkbox"
                id="rememberMe"
                [(ngModel)]="formData.rememberMe"
                name="rememberMe"
              />
              <span class="checkmark"></span>
              <span class="label-text">Remember me</span>
            </label>
          </div>

          <div *ngIf="errorMessage" class="alert" [ngClass]="{
            'alert-error': !isTenantDeactivated,
            'alert-warning': isTenantDeactivated
          }">
            {{ errorMessage }}
            <div *ngIf="isSubscriptionError" class="subscription-action">
              <button type="button" class="btn-renew" (click)="renewSubscription()">Renew Subscription</button>
            </div>
          </div>

          <button type="submit" class="btn-submit" [disabled]="loading || loginForm.invalid">
            <span *ngIf="!loading">Sign In</span>
            <span *ngIf="loading" class="spinner"></span>
          </button>

          <div class="signup-link">
            Don't have an account? <a routerLink="/register">Create Account</a>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
